import i18n from '@/i18n'
import { COMPANY_ADMIN_MENU_GROUP_KEY } from '@/constant/company'
import Layout from '../layout.vue'
import Index from './index.vue'
import RechargeList from './rechargeList.vue'

const baseUrl = '/v-admin/referral/cash-management'

export default {
  path: `${baseUrl}/`,
  redirect: `${baseUrl}/list`,
  component: Layout,
  meta: {
    isAllInclude: true,
    isNewPage: true,
    permission: ['PERM_REFERRAL_COMPANY_BALANCE_MANAGEMENT', 'COMPUTED_COMPANY_REFERRAL_ENABLED'],
    titleI18nKey: 'admin.company.cashPointsManagement.title.cashManagement',
    menu: {
      get label () {
        return i18n.t('admin.company.cashPointsManagement.menu.cashManagement')
      },
      group: COMPANY_ADMIN_MENU_GROUP_KEY.REFERRAL
    }
  },
  children: [
    {
      path: `${baseUrl}/list`,
      component: Index,
      meta: {
        isNewPage: true,
        breadcrumb: { hidden: true },
        titleI18nKey: 'admin.company.cashPointsManagement.title.cashManagement'
      }
    },
    {
      path: `${baseUrl}/:companyId/recharge-record`,
      component: RechargeList,
      meta: {
        isNewPage: true,
        titleI18nKey: 'admin.company.cashPointsManagement.title.rechargeRecord'
      }
    }
  ]
}
